import React from 'react';
import {
  Card,
  Form,
  Button,
  Input,
  Select,
  Row,
  Col,
  Icon,
  Tooltip,
  message as showMessage,
} from 'antd';

import { postData, getData } from '../../helper/dataService';
import API from '../../helper/api';
import Spinner from '../common/Spinner';
import { delayApiRequest } from '../../helper/utility';

class AssetAdd extends React.Component {
  state = {
    deviceFetching: false,
    deviceData: [],
    assetFetching: false,
    assetData: [],
    organizationData: [],
    servicePlanFetching: false,
    servicePlanData: [],
    submitted: false,
  };

  // * ASSET
  handleFetchAsset = (assetName) => {
    if (assetName.length >= 4) {
      delayApiRequest(() => this.fetchAsset(assetName));
    }
  };
  fetchAsset = (assetName) => {
    this.props.form.resetFields(['asset_oid']);
    this.setState({ assetData: [], assetFetching: true });

    getData(API.asset.search(assetName))
      .then(({ data: { data, status } }) => {
        if (status === 'success') {
          this.setState({ assetData: data });
        }
        this.setState({ assetFetching: false });
      })
      .catch(() => {
        showMessage.error('Sorry! Something went wrong');
        this.setState({ assetFetching: false });
      });
  };

  clearAsset = () => {
    this.setState({ assetData: [], deviceData: [] });
    this.props.form.resetFields(['asset_oid', 'device_oid', 'remarks']);
  };

  //* Device
  handleFetchDevice = (deviceName) => {
    if (deviceName.length >= 4) {
      delayApiRequest(() => this.fetchDevice(deviceName));
    }
  };

  fetchDevice = (deviceName) => {
    this.props.form.resetFields(['device_oid']);

    this.setState({ deviceData: [], deviceFetching: true });
    getData(API.device.search(deviceName))
      .then(({ data: { data, status } }) => {
        if (status === 'success') {
          this.setState({ deviceData: data });
        } else {
          showMessage.error('Sorry! Something went wrong');
        }
        this.setState({ deviceFetching: false });
      })
      .catch(() => {
        showMessage.error('Sorry! Something went wrong');
        this.setState({ deviceFetching: false });
      });
  };

  clearDevice = () => {
    this.setState({ deviceData: [] });
    this.props.form.resetFields(['device_oid']);
  };

  //* Organization
  handleFetchOrganization = (organizationName) => {
    if (organizationName.length >= 3) {
      delayApiRequest(() => this.fetchOrganization(organizationName));
    }
  };

  fetchOrganization = (organizationName) => {
    this.props.form.resetFields(['organization_oid']);

    this.setState({ organizationData: [], organizationFetching: true });
    getData(API.organization.search(organizationName))
      .then(({ data: { data, status } }) => {
        if (status === 'success') {
          this.setState({ organizationData: data });
        } else {
          showMessage.error('Sorry! Something went wrong');
        }
        this.setState({ organizationFetching: false });
      })
      .catch(() => {
        showMessage.error('Sorry! Something went wrong');
        this.setState({ organizationFetching: false });
      });
  };

  clearOrganization = () => {
    this.setState({ organizationData: [] });
    this.props.form.resetFields(['organization_oid']);
  };

  clearOrganization = () => {
    this.setState({ organizationData: [] });
    this.props.form.resetFields(['organization_oid']);
  };

  //* Service Plan
  componentDidMount() {
    this.fetchServicePlanList();
  }

  fetchServicePlanList = () => {
    this.setState({ servicePlanFetching: true });
    getData(API.servicePlan.list)
      .then(({ data: { data, status } }) => {
        if (status === 'success') {
          this.setState({ servicePlanData: data });
        } else {
          showMessage.error('Sorry! Something went wrong');
        }
        this.setState({ servicePlanFetching: false });
      })
      .catch(() => {
        showMessage.error('Sorry! Something went wrong');
        this.setState({ servicePlanFetching: false });
      });
  };

  // * set remarks
  setRemarks = (value) => {
    const asset = this.state.assetData.find(
      (asset) => asset._id.$oid === value
    );

    this.props.form.setFieldsValue({
      remarks: asset.remarks ? asset.remarks : '',
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ submitted: true });

        postData(API.asset.add, {
          ...values,
        })
          .then(({ data: { status, display } }) => {
            if (status === 'success') {
              showMessage.success(display);
              this.props.form.resetFields([
                'name',
                'asset_plate_number',
                'device_oid',
                'organization_oid',
                'asset_type',
                'asset_type',
                'service_plan',
                'device_sim_operator',
                'device_sim_number',
                'remarks',
              ]);
              this.setState({
                assetData: [],
                deviceData: [],
                organizationData: [],
              });
            } else if (status === 'failed') {
              showMessage.error(display);
            }
            this.setState({ submitted: false });
          })
          .catch(() => {
            showMessage.error('Sorry! Something went wrong');
            this.setState({ submitted: false });
          });
      }
    });
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const {
      assetData,
      deviceFetching,
      deviceData,
      organizationData,
      organizationFetching,
      servicePlanFetching,
      servicePlanData,
      submitted,
    } = this.state;

    const currentSelectedAsset = assetData.find(
      ({ _id }) => _id.$oid === getFieldValue('asset_oid')
    );
    const currentSelectedDevice = deviceData.find(
      ({ _id }) => _id.$oid === getFieldValue('device_oid')
    );
    const currentSelectedOrganization = organizationData.find(
      ({ _id }) => _id.$oid === getFieldValue('organization_oid')
    );
    const currentSelectedServicePlan = servicePlanData.find(
      ({ _id }) => _id.$oid === getFieldValue('service_plan')
    );

    return (
      <Row type='flex' justify='space-around' align='middle'>
        <Col xs={24} sm={18}>
          <Card
            title={
              <span className='title'>
                <Icon type='car' />
                {' Add Asset'}
              </span>
            }
          >
            <Form onSubmit={this.handleSubmit} layout='vertical'>
              <Form.Item
                label='Organization'
                extra={
                  currentSelectedOrganization ? (
                    <Button.Group size='small'>
                      <Button>{currentSelectedOrganization.name}</Button>
                      <Tooltip title='Remove Organization'>
                        <Button
                          icon='delete'
                          onClick={this.clearOrganization}
                        />
                      </Tooltip>
                    </Button.Group>
                  ) : null
                }
                {...formItemLayout}
              >
                {getFieldDecorator('organization_oid', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select a organization',
                    },
                  ],
                })(
                  <Select
                    showSearch
                    placeholder='Search and Select Organization'
                    filterOption={false}
                    notFoundContent={
                      organizationFetching ? <Spinner /> : 'No Content Found'
                    }
                    onSearch={this.handleFetchOrganization}
                    defaultActiveFirstOption={false}
                  >
                    {organizationData.length > 0 &&
                      organizationData.map(({ _id, name }) => (
                        <Select.Option key={_id.$oid}>{name}</Select.Option>
                      ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item
                label='Device IMEI'
                extra={
                  currentSelectedDevice ? (
                    <Button.Group size='small'>
                      <Button>
                        {currentSelectedDevice.imei} [
                        {currentSelectedDevice.device_id}] [
                        {currentSelectedDevice.device_type}]
                      </Button>
                      <Tooltip title='Remove device'>
                        <Button icon='delete' onClick={this.clearDevice} />
                      </Tooltip>
                    </Button.Group>
                  ) : null
                }
                {...formItemLayout}
              >
                {getFieldDecorator('device_oid', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select a device',
                    },
                  ],
                })(
                  <Select
                    showSearch
                    placeholder='Search and Select Device IMEI'
                    filterOption={false}
                    notFoundContent={
                      deviceFetching ? <Spinner /> : 'No Content Found'
                    }
                    onSearch={this.handleFetchDevice}
                    defaultActiveFirstOption={false}
                  >
                    {deviceData.length > 0 &&
                      deviceData.map(
                        ({ _id, imei, device_id, device_type }) => (
                          <Select.Option key={_id.$oid}>
                            {imei} [{device_id}] [{device_type}]
                          </Select.Option>
                        )
                      )}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label='Asset Name' {...formItemLayout}>
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: 'Please enter asset name',
                    },
                  ],
                })(<Input placeholder='Enter asset name' />)}
              </Form.Item>
              <Form.Item label='Asset Plate Number' {...formItemLayout}>
                {getFieldDecorator('asset_plate_number', {})(
                  <Input placeholder='Enter asset plate number' />
                )}
              </Form.Item>

              <Form.Item label='Asset Type' {...formItemLayout}>
                {getFieldDecorator('asset_type', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select asset type',
                    },
                  ],
                })(
                  <Select placeholder='Select Asset Type'>
                    <Select.Option value='Car'>Car</Select.Option>
                    <Select.Option value='Bus'>Bus</Select.Option>
                    <Select.Option value='Jeep'>Jeep</Select.Option>
                    <Select.Option value='Motorcycle'>Motorcycle</Select.Option>
                    <Select.Option value='Truck'>Truck</Select.Option>
                    <Select.Option value='Microbus'>Microbus</Select.Option>
                  </Select>
                )}
              </Form.Item>
              <Form.Item label='Service Plan' {...formItemLayout}>
                {getFieldDecorator('service_plan', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select a service plan',
                    },
                  ],
                })(
                  <Select
                    placeholder='Select Service Plan'
                    loading={servicePlanFetching}
                    notFoundContent={
                      servicePlanFetching ? <Spinner /> : 'No Content Found'
                    }
                  >
                    {servicePlanData.length > 0 &&
                      servicePlanData.map(({ _id, plan_name }) => (
                        <Select.Option key={_id.$oid} value={_id.$oid}>
                          {plan_name}
                        </Select.Option>
                      ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label='Sim Operator' {...formItemLayout}>
                {getFieldDecorator('device_sim_operator', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input sim operator',
                    },
                    {
                      max: 100,
                      message: 'The input not more than 100 characters.',
                    },
                  ],
                })(<Input placeholder='Sim Operator' />)}
              </Form.Item>
              <Form.Item label='Sim Number' {...formItemLayout}>
                {getFieldDecorator('device_sim_number', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input sim number',
                    },
                    {
                      max: 50,
                      message: 'The input not more than 50 characters.',
                    },
                  ],
                })(<Input placeholder='Sim Number' />)}
              </Form.Item>
              <Form.Item label='Remarks' {...formItemLayout}>
                {getFieldDecorator('remarks', {
                  initialValue: '',
                  rules: [
                    {
                      max: 250,
                      message: 'The input not more than 250 characters.',
                    },
                  ],
                })(<Input.TextArea placeholder='Remarks' rows={4} />)}
              </Form.Item>
              <Button
                type='primary'
                size='large'
                htmlType='submit'
                style={{ float: 'right' }}
                loading={submitted}
              >
                Submit
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default Form.create()(AssetAdd);
